<template>
  <div :class="style.selectComponent">
    <span v-if="comment" :class="style.comment">{{ comment }}</span>

    <ActionMenu
      v-model="isOpenSelect"
      :actions="popupItems"
      :teleport="true"
      :closeOnScroll="true"
      :closeOnResize="true"
      :minWidthByTrigger="true"
      placement="bottom-start"
      :offset="8"
      :popupStyle="computedPopupStyle"
      @open="$emit('open')"
      @close="$emit('close')"
    >
      <template #trigger="{isOpen, toggle}">
        <div
          data-floating-trigger
          :class="[
            style.select,
            style[`size${size}`],
            isOpen ? style.open : '',
            disabled ? style.disabled : ''
          ]"
          @click.stop="onSelectClick(toggle)"
        >
          <button :class="style.trigger" type="button" :disabled="disabled">
            <span :class="style.title">
              {{ text }}
            </span>

            <span :class="style.button" aria-hidden="true"></span>
          </button>
        </div>
      </template>
    </ActionMenu>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./Select.module.scss";
import ActionMenu from "@/elements/UI/popup/ActionMenu/ActionMenu.vue";

export default defineComponent({
  name: "SelectBase",

  components: {
    ActionMenu
  },

  emits: {
    select: (payload: SelectBasePayload): boolean => {
      return !!payload.item && typeof payload.index === "number";
    },

    open: (): boolean => true,

    close: (): boolean => true
  },

  props: {
    comment: {
      type: String,
      default: ""
    },

    text: {
      type: String,
      default: ""
    },

    items: {
      type: Array as PropType<SelectItem[]>,
      default: (): SelectItem[] => []
    },

    disabled: {
      type: Boolean,
      default: false
    },

    size: {
      type: String as PropType<Size>,
      default: "M"
    },

    stylePopup: {
      type: Object as PropType<Record<string, string | number>>,
      default: (): Record<string, string | number> => ({})
    }
  },

  data() {
    return {
      style,
      isOpenSelect: false
    };
  },

  computed: {
    popupItems(): ListActionItem[] {
      return this.items.map((item, index) => ({
        id:
          item.value !== undefined && item.value !== null
            ? String(item.value)
            : `${item.text}-${index}`,
        text: item.text,
        icon: item.icon,
        variant: item.variant,
        handler: () => {
          this.selectItem(item, index);
        },
        active: item?.active
      }));
    },

    computedPopupStyle(): Record<string, string | number> {
      return {
        ...this.stylePopup,
        padding: 0,
        boxSizing: "border-box"
      };
    }
  },

  methods: {
    onSelectClick(toggle: () => void): void {
      if (this.disabled) {
        return;
      }

      toggle();
    },

    selectItem(item: SelectItem, index: number): void {
      this.$emit("select", {
        item,
        index,
        value: item.value ?? item.text
      });
    }
  }
});
</script>
